import { Action } from '@ngrx/store';


export enum AdmModeloActionTypes {
  GET_ADM_MODELO = '[ADM_MODELO] GetModelo',
  SET_ADM_MODELO = '[ADM_MODELO] SetModelo',
  EDIT_ADM_MODELO = '[ADM_MODELO] EditModelo',
  DELETE_ADM_MODELO = '[ADM_MODELO] DeleteModelo',
  SUCESS_MODELO = '[ADM_MODELO] SuccessModelo',
  FAIL_MODELO = '[ADM_MODELO] FailModelo',
}

export class AdmGetModelo implements Action {
  readonly type = AdmModeloActionTypes.GET_ADM_MODELO;
  constructor(public Completo: boolean) {}
}

export class AdmSetModelo implements Action {
  readonly type = AdmModeloActionTypes.SET_ADM_MODELO;
  constructor(public DatosModelo: any) {}
}
export class AdmEditModelo implements Action {
  readonly type = AdmModeloActionTypes.EDIT_ADM_MODELO;
  constructor(public DatosModelo: any) {}
}

export class AdmDeleteModelo implements Action {
  readonly type = AdmModeloActionTypes.DELETE_ADM_MODELO;
  constructor(public ObjDel: any) {}
}

export class AdmSuscessModelo implements Action {
  readonly type = AdmModeloActionTypes.SUCESS_MODELO;
  constructor(public Respuesta: any , public TipoR: string) {}
}

export class AdmFailModelo implements Action {
  readonly type = AdmModeloActionTypes.FAIL_MODELO;
  constructor(public Respuesta: any) {}
}


export type AdmModeloAcciones =
    | AdmGetModelo
    | AdmSetModelo
    | AdmEditModelo
    | AdmDeleteModelo
    | AdmSuscessModelo
    | AdmFailModelo;
